import { api, prefix } from "@/api";
import { profileConfiguration } from "@/types/user";
import { type AxiosRequestConfig } from "axios";

const namespace = "profile";

export const getProfileSetting = (section: string = "", config: AxiosRequestConfig = {}) => {
  return api<any>({
    url: `${prefix}/profile/profilesetting/${section}`,
    method: "GET",
    ...config,
  });
};

export const addProfileSetting = (params: any = {}, config: AxiosRequestConfig = {}) => {
  return api<any>({
    url: `${prefix}/profile/profilesetting`,
    method: "POST",
    data: params,
    ...config,
  });
};

export const deleteProfileSetting = (id: number, config: AxiosRequestConfig = {}) => {
  if (id)
    return api<any>({
      url: `${prefix}/profile/profilesetting/${id}`,
      method: "DELETE",
      ...config,
    });
};

export const getListRoles = (params?: any, config: AxiosRequestConfig = {}) => {
  const query = new URLSearchParams(params).toString();
  return api<any>({
    url: `${prefix}/happyway/${namespace}/roles?${query}`,
    method: "GET",
    ...config,
  });
};

export const getAgoraCoachList = (params?: any, config: AxiosRequestConfig = {}) => {
  const query = new URLSearchParams(params).toString();
  return api<any>({
    url: `${prefix}/happyway/${namespace}/agoracoaches?${query}`,
    method: "GET",
    ...config,
  });
};

export const getConfiguration = (id: string, params?: any, config: AxiosRequestConfig = {}) => {
  const query = new URLSearchParams(params).toString();
  return api<profileConfiguration>({
    url: `${prefix}/${namespace}/configuration/${id}?${query}`,
    method: "GET",
    ...config,
  });
};
